import { useState, useEffect, useRef } from 'react';
import useAuth from './useAuth';
// API
import API from '../API';
const initialState = {
  page: 0,
  currentPayslip: '',
  total_pages: 0,
  total_results: 0
};
export const useCurrentPayslipFetch = id => {
  const auth = useAuth();
  const [currentPayslipstate, currentPayslipsetState] = useState(initialState);
  const [currentPaysliploading, currentPayslipsetLoading] = useState(false);
  const [currentPaysliperror, currentPayslipsetError] = useState(false);
  const [currentPaysliptrigger, currentPayslipsetTrigger] = useState(false);
  const accessToken = auth.auth.accessToken
  console.log("binne use curentPayslip fetch")
  console.log(id)
  useEffect(()=>{
    console.log("binne use Employee fetch se useEffect")
    const fetchCurrentPayslip = async()=>{
      try {
        currentPayslipsetLoading(true);
        currentPayslipsetError(false);
       currentPayslipsetTrigger(false)
        const currentPayslip = await API.fetchCurrentPayslip(id,accessToken)
       
        console.log(currentPayslip)
        currentPayslipsetState({  
          ...currentPayslip.currentPayslip[0]
          
        }
        )

        currentPayslipsetLoading(false)

      } catch (error) {
        console.log(error)
        currentPayslipsetError(true);
      }
    }
    fetchCurrentPayslip()
  },[id,currentPaysliptrigger]);

return{currentPayslipstate,currentPayslipsetState,currentPaysliploading,currentPaysliperror,currentPayslipsetLoading,currentPayslipsetTrigger};


};
